import script from "./LbrxCategoryBarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./LbrxCategoryBarItem.vue?vue&type=script&lang=ts&setup=true"

import "./LbrxCategoryBarItem.vue?vue&type=style&index=0&id=463f0526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463f0526"]])

export default __exports__